// node_modules
import { FC, useContext, useEffect } from "react";
// Enums
import { ReferenceTypeEnum } from "Enums";
// Types
import { TReference } from "Types";
import { TechnologyImageModalContent } from "./TechnologyImageModalContent";
import { TechnologyInternalLinkModalContent, } from "./TechnologyInternalLinkModalContent";
import { PatentModalContent } from "../PatentModalContent";
import { ScienceArticleModalContent } from "../ScienceArticleModalContent";
import { TechnologyModalContent } from "../TechnologyModalContent";
import { TechnologyYoutubeVideoModalContent } from "./TechnologyYoutubeVideoModalContent";
import { CloseModalButton } from "..";
// Stores
import { CaseContext } from "Stores";
// Icons

type TTechnologyReferenceModalContentProps = {
    reference: TReference | undefined,
    closeModal: () => void
}

// This dialog is opened when a user clicks on a reference in a technology ()
// Reference: href link adding an anchor to the URL
// Type of reference: technology's document, an other technology, technology's media (image/youtube video), technology's supplier/weblink
export const TechnologyReferenceModalContent: FC<TTechnologyReferenceModalContentProps> = ({reference, closeModal}: TTechnologyReferenceModalContentProps) => {
    // Shared states
    const { caseState } = useContext(CaseContext);
    
    // Automatically close the modal if something is wrong with the modal data (passed as props in reference object)
    useEffect(() => {
        if (!reference || (reference && !reference.referenceId)) {closeModal();}
    }, [reference, closeModal]);

    // Get modal content based on reference type
    const getTechnologyReferenceModalContent = (): JSX.Element | null => {
        if (!reference || (reference && !reference.referenceId)) {return null;}

        if (!reference.technologyId && caseState.selectedTechnologyId) {
            reference.technologyId = caseState.selectedTechnologyId.toString();
        }

        switch (reference.type) {
            case ReferenceTypeEnum.ScienceArticle:
                return <ScienceArticleModalContent scienceArticleId={reference.referenceId} />;
            case ReferenceTypeEnum.Patent:
                return <PatentModalContent patentId={reference.referenceId} />;
            case ReferenceTypeEnum.InternalLink:
                if (!reference.technologyId) {return null;}
                return <TechnologyInternalLinkModalContent technologyId={reference.technologyId} internalLinkId={reference.referenceId} />;
            case ReferenceTypeEnum.Technology:
                return <TechnologyModalContent technologyId={reference.referenceId} />;
            case ReferenceTypeEnum.Image:
                if (!reference.technologyId) {return null;}
                return <TechnologyImageModalContent technologyId={reference.technologyId} imageId={reference.referenceId} />;
            case ReferenceTypeEnum.YoutubeVideo:
                if (!reference.technologyId) {return null;}
                return <TechnologyYoutubeVideoModalContent technologyId={reference.technologyId} youtubeVideoId={reference.referenceId} />;
            default:
                return null;
        }
    };

    return (
        <>
            <CloseModalButton onClick={closeModal}/>
            {(reference && reference.referenceId) ?
                getTechnologyReferenceModalContent()
                : 
                <div>An error occurred while opening the modal.</div>
            }
        </>
    );
};